import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper from '../chart_helpers/AxisHelper'
import { continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import SizeHelper from '../chart_helpers/SizeHelper'

import { extent as d3_extent } from 'd3-array'
import { scaleLinear as d3_scaleLinear } from 'd3-scale'
import { wrapSvgText } from '../utils/textUtils'
import { getBrightness } from '../utils/colorUtils'

const DEFAULT_SCATTER_R = 6
export default class ScatterPlotChart extends BaseChart {
  constructor(...args) {
    super(...args)
  }
  static defaultConfig = {
    groupAttr: {
      type: String,
      default: 'group',
    },
    xAttr: {
      type: String,
      default: 'x',
    },
    yAttr: {
      type: String,
      default: 'y',
    },
    sizeAttr: {
      type: [String, null],
      default: 'size',
    },
    mode: {
      type: [String],
      default: 'dots',
      options: ['dots', 'grid'],
    },
    /**
     * If set, all data points will have at least this radius.
     */
    minSize: {
      type: Number,
      default: 0,
      exposed: true,
    },
    /**
     * If set, all data points will have at most this radius.
     */
    maxSize: {
      type: Number,
      default: Infinity,
      exposed: true,
    },
    /**
     * Show/hide the label of each data point.
     */
    showLabels: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    showHeatValues: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    AxisHelper: {
      zoom: false,
      x: {
        scale: 'linear',
        getValue: function (d) {
          return d.x
        },
        getExtent: function (data) {
          let extent = continuousExtent(data, d => d[this.config.xAttr]) // d3_extent(data.map((d)=>d[this.config.xAttr]))
          // return padLinear(extent,0.2)
          return extent
        },
        grid: true,
      },
      y: {
        scale: 'linear',
        getValue: function (d) {
          return d.y
        },
        getExtent: function (data) {
          let extent = continuousExtent(data, d => d[this.config.yAttr]) //d3_extent(data.map((d)=>d[this.config.yAttr]))
          // return padLinear(extent,0.2)
          return extent
        },
        grid: true,
      },
    },
  }
  static helpers = [RootHelper, ItemsHelper, SelectableHelper, SizeHelper, AxisHelper]
  checkConsistency() {
    return true
  }
  // getLegendData() {
  //   let legendData = {}
  //   if (this.config.groupAttr) {
  //     let groups = this.data.reduce((res, d) => {
  //       res.push(d.group)
  //       return res
  //     }, [])
  //     groups = groups.filter((d, i) => groups.indexOf(d) === i)
  //     let groupData = groups.map(g => {
  //       return { id: g, group: g }
  //     })
  //     legendData.group = groupData
  //     legendData.group.icon = 'circle'
  //   }

  //   if (this.config.sizeAttr) {
  //     let sizes = this._sizeScale.nice().ticks(3)
  //     sizes = [sizes[0], sizes[sizes.length - 1]]
  //     sizes.splice(1, 0, sizes[0] + (sizes[1] - sizes[0]) / 2)

  //     let sizeData = sizes.map(d => ({ id: d, value: 2 * this._sizeScale(d) }))

  //     legendData.size = sizeData
  //     legendData.size.icon = 'circle'
  //     legendData.size.type = 'size'
  //   }
  //   return legendData
  // }
  beforeHelpers() {
    this._sizeScale = d3_scaleLinear()
      .domain(d3_extent(this.data, d => d.size))
      .range([3, 15])
  }
  draw() {
    if (this.config.mode === 'grid') {
      this.itemsEnter
        .selectAll('.square')
        .data([null])
        .enter()
        .append('g')
        .attr('class', 'square')
        .append('rect')
      // this.itemsEnter.call(drawItem,'enter')
      this.itemsEnter
        .select('.square')
        .attr(
          'transform',
          d =>
            `translate(${this.axes.x.func.scale()(d[this.config.xAttr])},${this.axes.y.func.scale()(
              d[this.config.yAttr]
            )})`
        )
        .select('rect')
        .attr('fill', d => this.color(d) || 'none')
        .attr('width', () => this.axes.x.func.scale().bandwidth())
        .attr('height', () => this.axes.y.func.scale().bandwidth())
        .style('opacity', 0)

      this.itemsEnter
        .select('.square')
        .append('text')
        .attr('class', 'text')
        .attr('text-anchor', 'middle')
        .attr('dominant-baseline', 'middle')
        .attr('x', this.axes.x.func.scale().bandwidth() / 2)
        .attr('y', this.axes.y.func.scale().bandwidth() / 2)
        .text(d => this.formatValue(d.value))
        .style('opacity', 0)
      this.itemsEnterTrans.select('.square').select('rect').style('opacity', 1)
      this.itemsEnterTrans.select('.text').style('opacity', () => {
        if (!this.config.showHeatValues) return 0
        else if (
          this.axes.x.func.scale().bandwidth() < 60 ||
          this.axes.y.func.scale().bandwidth() < 20
        )
          return 0
        else return 1
      })
      this.itemsTrans
        .select('.square')
        .attr(
          'transform',
          d =>
            `translate(${this.axes.x.func.scale()(d[this.config.xAttr])},${this.axes.y.func.scale()(
              d[this.config.yAttr]
            )})`
        )
        .select('rect')
        .attr('fill', d => this.color(d) || 'none')
        .attr('width', () => this.axes.x.func.scale().bandwidth())
        .attr('height', () => this.axes.y.func.scale().bandwidth())
        .style('opacity', 1)

      this.itemsTrans
        .select('.text')
        .text(d => this.formatValue(d.value))
        .style('opacity', () => {
          if (!this.config.showHeatValues) return 0
          else if (
            this.axes.x.func.scale().bandwidth() < 60 ||
            this.axes.y.func.scale().bandwidth() < 20
          )
            return 0
          else return 1
        })
        .attr('x', this.axes.x.func.scale().bandwidth() / 2)
        .attr('y', this.axes.y.func.scale().bandwidth() / 2)
        .attr('fill', d => {
          let brightness = getBrightness(this.color(d))
          return brightness < 140 ? '#fff' : '#000'
        })
      this.itemsExitTrans.style('opacity', 0)
    } else {
      let safeR = d => {
        let max = this.config.maxSize ? this.config.maxSize : Infinity
        let min = this.config.minSize ? this.config.minSize : 0
        return this.config.sizeAttr
          ? Math.max(min, Math.min(max, this._sizeScale(d.size)))
          : DEFAULT_SCATTER_R
      }
      this.itemsEnter
        .selectAll('.point')
        .data([null])
        .enter()
        .append('g')
        .attr('class', 'point')
        .append('circle')
      this.itemsEnter
        .select('.point')
        .attr(
          'transform',
          d =>
            `translate(${this.axes.x.func.scale()(d[this.config.xAttr])},${this.axes.y.func.scale()(
              d[this.config.yAttr]
            )})`
        )
        .select('circle')
        .attr('fill', d => this.color(d))
        .attr('r', 0)
      this.itemsEnterTrans.select('.point').select('circle').attr('r', safeR)

      let mergedItems = this.items.merge(this.itemsEnter)
      let labels = mergedItems
        .select('.point')
        .selectAll('text')
        .data(this.config.showLabels ? [null] : [])
      labels
        .enter()
        .append('text')
        // .attr('text-anchor','middle')
        .attr('font-size', '14px')
        .attr('fill', 'currentColor')
      labels.exit().transition().style('opacity', 0).remove()

      mergedItems
        .select('.point')
        .select('text')
        .text(d => d.id)
        .call(wrapSvgText, 80)
        .attr('transform', d => `translate(${safeR(d) + 6},-${safeR(d) + 6})`)
        .selectAll('tspan')
        .attr('x', 0)
        .attr('y', 0)

      this.itemsEnter.select('.point').select('text').attr('opacity', 0)
      this.itemsEnterTrans.select('.point').select('text').attr('opacity', 1)
      this.itemsTrans
        .select('.point')
        .attr(
          'transform',
          d =>
            `translate(${this.axes.x.func.scale()(d[this.config.xAttr])},${this.axes.y.func.scale()(
              d[this.config.yAttr]
            )})`
        )
        .select('circle')
        .attr('fill', d => this.color(d))
        .attr('r', safeR)

      this.itemsExitTrans.style('opacity', 0)
    }
  }
}
